"use client";

import Image from "next/image";
import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function ImageZoom({ src, alt, children, className = "" }: { src: string; alt: string; children: ReactNode; className?: string }) {
  return <Dialog>
    <DialogTrigger asChild>
      <button type="button" className={`image-zoom-trigger ${className}`} aria-label={`Agrandir l’image : ${alt}`}>
        {children}
        <span className="sr-only">Agrandir l’image</span>
      </button>
    </DialogTrigger>
    <DialogContent className="image-zoom-dialog">
      <DialogTitle className="sr-only">{alt}</DialogTitle>
      <DialogDescription className="sr-only">Aperçu agrandi de l’image.</DialogDescription>
      <Image src={src} alt={alt} width={1600} height={1200} className="image-zoom-dialog-image" />
    </DialogContent>
  </Dialog>;
}
